var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-dim flex-col"},[_c('div',{staticClass:"safe-area absolute"},[_vm._m(0),_c('div',{on:{"click":function($event){return _vm.closeRefundSucceedPopup()}}},[_c('bottom-button',{attrs:{"buttonArray":_vm.buttonArray}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-wrap"},[_c('div',[_c('span',[_vm._v("환불신청이")]),_c('span',[_vm._v("완료되었습니다.")])])])
}]

export { render, staticRenderFns }